import { IMdfActivity } from 'partner360/features/mdfActivities/model/types'

export const transformActivitiesFieldToOptions = (
  activities: IMdfActivity[],
  getValue: (activity: IMdfActivity) => string | string[]
) =>
  Array.from(
    new Set(
      activities
        .flatMap((activity) => {
          const value = getValue(activity)
          return Array.isArray(value) ? value : [value]
        })
        .filter(Boolean)
    )
  )
    .sort()
    .map((value) => ({ key: value, label: value }))
